import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationMessagesComponent } from './components/validation-messages/validation-messages.component';
import { OnlyNumberDirective } from './directives/only-number.directive';

@NgModule({
	declarations: [ValidationMessagesComponent, OnlyNumberDirective],
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	exports: [ValidationMessagesComponent, OnlyNumberDirective]
})
export class SharedModule {}
